import { Fragment, type ReactNode } from 'react'
import { type ColumnGroupSpan, GROUP_DIVIDER_CLASS, getGroupLabelOffset } from './Table.utils'

type TableGroupHeadersProps = {
  spans: ColumnGroupSpan[]
  columnWidth: number
  firstColumnWidth: number
  rowHeight: number
  /** Height of the group row and the column header row together, which the divider after each group spans. */
  headerHeight: number
  scrollLeft: number
}

/**
 * One header cell per group, spanning the group's columns, and a divider after it down through the column
 * headers; the label follows the left edge while scrolled.
 */
export function TableGroupHeaders({
  spans,
  columnWidth,
  firstColumnWidth,
  rowHeight,
  headerHeight,
  scrollLeft,
}: TableGroupHeadersProps): ReactNode {
  return spans.map((span) => {
    const spanLeft = span.startIndex * columnWidth
    const spanWidth = span.columnCount * columnWidth
    const labelOffset = getGroupLabelOffset({ spanLeft, spanWidth, scrollLeft, minVisibleWidth: columnWidth })

    return (
      <Fragment key={span.startIndex}>
        <div
          className="absolute top-0 flex items-end overflow-hidden border-r border-b border-gray-200 border-b-gray-300 bg-white text-sm font-bold"
          style={{ left: `${spanLeft + firstColumnWidth}px`, width: `${spanWidth}px`, height: `${rowHeight}px` }}
          title={span.label}
        >
          <div className="truncate px-2 pb-1" style={{ marginLeft: `${labelOffset}px` }}>
            {span.label}
          </div>
        </div>
        <div
          className={`${GROUP_DIVIDER_CLASS} top-0 z-[35]`}
          style={{ left: `${spanLeft + spanWidth + firstColumnWidth - 1}px`, height: `${headerHeight}px` }}
        />
      </Fragment>
    )
  })
}
